import SlimSelect from "slim-select"

const panesSelector = '.form__pane';
const formSelector = 'form';
const selectSelector = 'select';
const paneActiveClass = 'form__pane--active';
const successPaneSelector = '.form__pane--success'
const errorPaneSelector = '.form__pane--error'
const inputSelector = 'input[type=email]'
const submitSelector = '.btn__send'

export class FormHandler {

    private el: HTMLElement
    private clearForm: HTMLFormElement
    private form: HTMLFormElement
    private select: HTMLSelectElement
    private input: HTMLInputElement
    private panes: NodeList
    private successPane: HTMLElement
    private errorPane: HTMLElement
    private slimSelect: SlimSelect
    private submit: HTMLElement
    private loading: boolean = false;


    init(el: HTMLElement){
        this.el = el;
        this.form = this.el.querySelector(formSelector);

        if (!this.clearForm) {
            this.clearForm = this.form.cloneNode(true) as HTMLFormElement;
        }

        this.input = this.form.querySelector(inputSelector);
        this.select = this.form.querySelector(selectSelector);
        this.panes = this.el.querySelectorAll(panesSelector);
        this.successPane = this.el.querySelector(successPaneSelector);
        this.errorPane = this.el.querySelector(errorPaneSelector);
        this.submit = this.form.querySelector(submitSelector);

        if (this.select) {
            this.slimSelect = new SlimSelect({
                select: this.select,
                showContent: 'down',
                showSearch: false
            })
        }

        this.bindEvents();
    }
    checkEmail(emailAddress: string) {
        var sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
        var sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
        var sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
        var sQuotedPair = '\\x5c[\\x00-\\x7f]';
        var sDomainLiteral = '\\x5b(' + sDtext + '|' + sQuotedPair + ')*\\x5d';
        var sQuotedString = '\\x22(' + sQtext + '|' + sQuotedPair + ')*\\x22';
        var sDomain_ref = sAtom;
        var sSubDomain = '(' + sDomain_ref + '|' + sDomainLiteral + ')';
        var sWord = '(' + sAtom + '|' + sQuotedString + ')';
        var sDomain = sSubDomain + '(\\x2e' + sSubDomain + ')*';
        var sLocalPart = sWord + '(\\x2e' + sWord + ')*';
        var sAddrSpec = sLocalPart + '\\x40' + sDomain; // complete RFC822 email address spec
        var sValidEmail = '^' + sAddrSpec + '$'; // as whole string

        var reValidEmail = new RegExp(sValidEmail);

        return reValidEmail.test(emailAddress);
    }

    validate(){
        const formInputs = [...Array.from(this.form.querySelectorAll('form .form__input-wrapper'))]
        const formCheckboxes = [...Array.from(this.form.querySelectorAll('form .checkbox__required'))]
        let valid = true;
        formInputs.forEach( (el: HTMLElement) => {
            //@ts-ignore
            if (el.classList.contains('form__input--required') && el.querySelector('input,textarea') && el.querySelector('input,textarea').value.length === 0){
                valid = false;
                el.querySelector('input,textarea').classList.add('form__input--error');
            } else {
                el.querySelector('input,textarea')?.classList.contains('form__input--error') ? el.querySelector('input,textarea').classList.remove('form__input--error') : '';
            }

            if (el.querySelector('input[type=email]')){
                //@ts-ignore
                if(!this.checkEmail(el.querySelector('input[type=email]').value)){
                    valid = false;
                    el.querySelector('input').classList.add('form__input--error');
                }
            }
        })

        formCheckboxes.forEach( (el: HTMLElement) => {

            //drop checking if the element is hidden
            if (!el.offsetWidth) {
                return;
            }

            //@ts-ignore
            if (el.querySelector('input[type=checkbox]').checked !== true){
                valid = false;
                el.classList.add('form__input--error');
            } else {
                el.classList.contains('form__input--error') ? el.classList.remove('form__input--error') : '';
            }
        })

        if (!valid) {

            console.log('scroll to ', this.form
                .querySelector('.form__input--error')
                .closest('.form__input-wrapper,.checkbox__required'));

            this.form
                .querySelector('.form__input--error')
                .closest('.form__input-wrapper,.checkbox__required')
                .scrollIntoView({behavior: 'smooth'});

        }

        return valid;
    }

    constructor(el: HTMLElement) {
        this.init(el);
    }

    bindEvents() {
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();

            if (!this.validate()) {
                return;
            }

            if (this.loading) {
                return;
            }

            this.submit.classList.add('btn__send--loading');
            this.loading = true;


            let formData = new FormData(this.form);
// if (typeof window.grecaptcha !== "undefined") {
//     console.log("grecaptcha załadowany");
// } else {
//     console.log("grecaptcha nie jest załadowany");
// }
            const siteKeyCaptchaField:HTMLInputElement = this.form.querySelector('input[name="sitekey_captcha"]') as HTMLInputElement | null;
        //   if (siteKeyCaptchaField != null) {
        //     console.log(siteKeyCaptchaField.value);
        //   }

   if (siteKeyCaptchaField != null) {
       const siteKeyCaptcha = siteKeyCaptchaField.value;

       //@ts-ignore
       grecaptcha.ready(() => {
           //@ts-ignore
           grecaptcha.execute(siteKeyCaptcha, { action: 'submit' })
               .then((token) => {
                   formData.append('return_captcha', token);
                   fetchData(formData,this);
               })
       });
   } else {
        fetchData(formData,this);
   }

   function fetchData(formData,context) {
    fetch(context.form.getAttribute('action'), {
        method: context.form.getAttribute('method').toUpperCase() || 'POST',
        body: formData
    }).then(response => {

        response.json().then(data => {

            context.submit.classList.remove('btn__send--loading');
            context.loading = false;

            // do something with your data
            console.log('Jeszcez wiekszy SUKCES', data);

            if (data && data.status) {
                // console.log('sukces najwiÄ™kszy');
                context.showPane('success');
                // this.input.value = '';

            } else {
                context.showPane('error');
            }

        }, (error) => {

            context.submit.classList.remove('btn__send--loading');
            context.loading = false;

            context.showPane('error');
            console.log('NIE ma wiekszego SUKCESu :(', error)
        });

        console.log('SUKCES', response);
    }, error => {

        context.submit.classList.remove('btn__send--loading');
        context.loading = false;

        context.showPane('error');
        console.log('NIE SUKCES :(', error)
    });
}

        });
        this.successPane.addEventListener('click', (event) => {
            const newForm = this.clearForm.cloneNode(true) as HTMLFormElement;
            if (this.slimSelect) {
                console.log('before destroy');
                this.slimSelect.destroy();
                console.log('after destroy');
            }
            this.form.parentNode.replaceChild(newForm, this.form);
            this.init(this.el);
            this.showPane('form');
        });
        this.errorPane.addEventListener('click', (event) => {
            this.showPane('form');
        });
    }

    showPane(name) {
        let currentPane = null;
        this.panes.forEach((pane: HTMLElement) => {
            pane.matches(panesSelector + '--' + name) ? (pane.classList.add(paneActiveClass), currentPane = pane) : pane.classList.remove(paneActiveClass)
        });
        if (currentPane) currentPane.scrollIntoView({behavior: 'smooth'});

    }

}

export class Forms {

    private formInstances: Array<FormHandler> = [];
    private forms: NodeList;

    init() {

        if (document.getElementsByTagName('body')[0].classList.contains('neos-backend')) {
            return;
        }

        this.forms = document.querySelectorAll('.form:not(.form--custom-script)');

        this.forms.forEach((elem: HTMLElement, index) => {
            this.formInstances[index] = new FormHandler(elem);
        })

    }

}
